/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface VcfOrgAssignResourceSpec { 
    region?: string;
    /**
     * Resource Id
     */
    resource_id?: string;
    service_type: ServiceTypeEnum;
    /**
     * Org Id
     */
    vcf_org_id: string;
}
export namespace VcfOrgAssignResourceSpec {
}


